import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col gap-8 p-6 max-w-4xl mx-auto bg-white shadow-lg rounded-lg mt-10">
      <h1 className="text-3xl font-bold text-gray-800">Privacy Policy</h1>
      <p className="text-gray-600">
        This Privacy Policy explains how we collect, use, and (under certain
        conditions) disclose your personal information. It also explains the
        steps we have taken to secure your personal information and your options
        regarding the collection, use, and disclosure of your personal
        information. By visiting the Site directly or through another site, you
        accept the practices described in this Policy.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800">Data Collection</h2>
      <p className="text-gray-600">
        We may collect various pieces of information if you seek to place an
        order for a product with us on the Site. This includes your title, name,
        gender, date of birth, email address, postal address, delivery address,
        telephone number, mobile number, fax number, payment details, and bank
        account details.
      </p>
      <ul className="list-disc list-inside text-gray-600">
        <li>Identity data (name, gender, date of birth, etc.)</li>
        <li>
          Contact data (billing address, delivery address, email, phone numbers)
        </li>
        <li>Biometric data (voice files, face recognition)</li>
        <li>
          Billing account information (bank account details, credit card
          details)
        </li>
        <li>Transaction records/data (orders, payments, user clicks)</li>
        <li>Technical data (IP address, login data, browser type, etc.)</li>
        <li>Profile data (username, password, preferences, feedback)</li>
        <li>Usage data (how you use the Site, access times, dates)</li>
        <li>Location data (location with photos or videos)</li>
        <li>
          Marketing and communications data (preferences, communication history)
        </li>
        <li>Additional information for due diligence checks</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800">
        Use of Information
      </h2>
      <p className="text-gray-600">
        We will use the information you provide to enable us to process your
        orders and to provide you with the services and information offered
        through our website, which includes:
      </p>
      <ul className="list-disc list-inside text-gray-600">
        <li>Processing your orders for products</li>
        <li>Delivering the products you have purchased</li>
        <li>Providing customer support for your orders</li>
        <li>Verifying and carrying out payment transactions</li>
        <li>Facilitating your use of the services or access to the Site</li>
        <li>Administering your account with us</li>
        <li>Displaying your name, username, or profile on the Site</li>
        <li>Responding to your queries, feedback, claims, or disputes</li>
        <li>Providing marketing and promotional information</li>
        <li>Ensuring legal and operational compliance</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800">
        Third-Party Disclosure
      </h2>
      <p className="text-gray-600">
        We may pass your details to other companies in our group and to our
        agents and subcontractors to help us with any of our uses of your data
        set out in our Privacy Policy. For example, we may use third parties to
        assist us with delivering products to you, to help us collect payments
        from you, to analyze data, and to provide us with marketing or customer
        service assistance.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800">Cookies</h2>
      <p className="text-gray-600">
        We or our authorized service providers may use cookies, web beacons, and
        other similar technologies in connection with your use of the Site. The
        acceptance of cookies is not a requirement for visiting the Site.
        However, note that certain functionalities (like the 'basket'
        functionality) may only be possible with the activation of cookies.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800">Security</h2>
      <p className="text-gray-600">
        We have in place appropriate technical and security measures to prevent
        unauthorized or unlawful access to or accidental loss of or destruction
        or damage to your information. However, no method of transmission over
        the Internet or method of electronic storage is completely secure.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800">Your Rights</h2>
      <p className="text-gray-600">
        If you are concerned about your data, you have the right to request
        access to the personal data we hold or process about you. You have the
        right to require us to correct any inaccuracies in your data free of
        charge. At any stage, you also have the right to ask us to stop using
        your personal data for direct marketing purposes.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800">Minors</h2>
      <p className="text-gray-600">
        We do not sell products to minors, i.e., individuals below the age of
        18, on the Site and we do not knowingly collect any personal data
        relating to minors. You hereby confirm and warrant that you are above
        the age of 18 and are capable of understanding and accepting the terms
        of this Privacy Policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
